import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsHelper} from "../../utils/FruitsHelper";


export class FruitsReelAttentionView extends BaseView {

    private _layer:ScalableLayer;
    private _orientation:Orientation;
    private _positions:number[][];

    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.STICKY_SYMBOL.name);

        this._positions = [
            [4, 5, 6],
            [7, 8, 9],
            [10, 11, 12],
            [13, 14, 15],
        ];
    }


    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._orientation = Orientation.PORTRAIT;
        } else {
            this._orientation = Orientation.LANDSCAPE;
        }
    }

    private createFx(reelId:number):TimelineSprite {

        let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(reelId);
        let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);

        const effect:TimelineSprite = new TimelineSprite(GameResources.getTextures("excitementFX"));
        effect.blendMode = PIXI.BLEND_MODES.ADD;
        effect.hide();
        effect.anchor.set(0.5, 0.5);
        effect.position.set(rectPos[0], rectPos[1]);
        this._layer.addChild(effect);
        return effect;
    }

    public getAttention(reel:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        this._positions[reel - 2].forEach((reelId, index) => {

            const effect = this.createFx(reelId);
            if(this._orientation === Orientation.LANDSCAPE ? index === 0 : index === 2) {
                tl.add(() => SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_ANTICIPATION), 0);
            }
            tl.add(effect.getAnimationAutoShowHide(true, true), 0);
            tl.add(() => this._layer.removeChild(effect));
        });
        return tl;
    }


}